import { render, staticRenderFns } from "./DeviceVirtual.vue?vue&type=template&id=0a336ebf&"
import script from "./DeviceVirtual.vue?vue&type=script&lang=js&"
export * from "./DeviceVirtual.vue?vue&type=script&lang=js&"
import style0 from "./DeviceVirtual.vue?vue&type=style&index=0&id=0a336ebf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports